<template>
    <h1 :id="content.Anker">{{ content.Ueberschrift }}</h1>
    <div v-html="content.Text"/>
</template>

<script>
export default {
    props: [
        "content"
    ],
}
</script>